import { toast } from './queryClient';

export const successToast = (description: string) => {
  toast({
    title: 'Success',
    description,
    duration: 10000,
    isClosable: true,
    status: 'success',
  });
};
